import { useCan, useSubjectLanguageVariants } from '@features/user';
import { Skeleton } from '@mui/material';
import { FeatureGates, useFeatureGate } from '@services/statsig';

import { useRequestCopy } from '../store/useRequestCopy';

import { RequestCopyEditor } from './RequestCopyEditor';

/**
 * The Settings default-message editor, wired (AC-11, GDN-3230).
 *
 * Gated the same way as the catalog it sits under: the Statsig gate is
 * rollout, `manage_organization` is the practice-admin check that makes this
 * page admin-only. A provider who reaches it without the permission reads the
 * copy and edits nothing — the per-launch preview is not admin-only, so the
 * text itself is not privileged.
 */
export const RequestCopySection = () => {
  const enabled = useFeatureGate(FeatureGates.PATIENT_REQUIREMENTS);
  const isAdmin = useCan('manage_organization');
  const subject = useSubjectLanguageVariants();

  const copy = useRequestCopy(enabled);

  if (!enabled) return null;

  if (copy.isLoading) {
    return <Skeleton variant="rounded" height={280} sx={{ mt: 2 }} />;
  }

  return (
    <RequestCopyEditor
      draft={copy.draft}
      smsIsDefault={copy.smsIsDefault}
      emailIsDefault={copy.emailIsDefault}
      smsSegmentHint={copy.smsSegmentHint}
      linkPlaceholder={copy.linkPlaceholder}
      smsPreview={copy.smsPreview}
      previewIsStale={copy.previewIsStale}
      canEdit={isAdmin}
      status={copy.status}
      isDirty={copy.isDirty}
      errorMessage={copy.errorMessage}
      subject={subject}
      onChange={copy.onChange}
      onSave={copy.onSave}
      onResetChannel={copy.onResetChannel}
    />
  );
};
